module.exports = __webpack_public_path__ + "static/media/icono cargar foto perfil panel.bfb73b0f.svg";